import classNames from 'classnames/bind';
import * as SELECTORS from '@/constants/selectors';
import styles from './Main.module.scss';
import { useContext } from 'react';
import { NetspendContext } from 'library/contexts/NetspendContext';

let cx = classNames.bind(styles);

export function Main({ children, className, ...props }) {
	const { stripeHeight } = useContext(NetspendContext);
  
  return (
    <main
      id={SELECTORS.MAIN_CONTENT_ID}
      tabIndex={-1}
      className={cx(['ns_main', 'main', className])}
      style={stripeHeight && {'--stripeHeight': `${stripeHeight}px`}}
      {...props}
    >
      {children}
    </main>
  );
}
